export default "__VITE_ASSET__Dlosm9K$__"